<template>
  <v-autocomplete
    :disabled="disabled"
    :multiple="multiple"
    :required="required"
    chips
    placeholder="Start typing to Search"
    return-object
    :label="label"
    :items="uploads"
    v-model="internalSelected"
    item-text="name"
    item-value="id"
    max-height="auto"
    autocomplete
  >
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        @click="data.select"
        @click:close="remove(data.item)"
      >
        <v-icon medium color="primary">mdi-file-check</v-icon>
        &nbsp;
        <span v-if="data.item.name.length < 8">{{ data.item.name }}</span>
        <span v-else>{{ data.item.name.substring(0, 8) + '..' }}</span>
      </v-chip>
    </template>

    <template v-slot:item="{ item }">
      <template v-if="typeof item !== 'object'">
        <v-list-item-content v-text="item"></v-list-item-content>
      </template>
      <template v-else>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'UploadsSelect',
  props: {
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    uploads: {
      type: Array,
      default: () => []
    },
    selected: {
      type: [Array, Object],
      default: () => []
    }
  },
  data() {
    return {
      internalSelected: []
    };
  },
  watch: {
    internalSelected: function (newValue) {
      console.log('onSelect');
      this.$emit('onSelect', newValue);
    },
    selected(newVal) {
      this.internalSelected = newVal || [];
    }
  },
  created() {
    if (this.selected) {
      this.internalSelected = this.selected || [];
    }
  },
  methods: {
    remove(item) {
      if (!this.multiple) this.internalSelected = undefined;
      else {
        this.internalSelected = this.internalSelected.filter(
          (el) => el.id !== item.id
        );
      }
      this.$emit('onRemove', item);
    }
  }
};
</script>
